import {APPLICATION_LOGIN_PATH, USER_API_PATH} from '../../config/config.js';
import {initPhoneNumber} from '../../functions/intrernationalPhoneNumber';
import s3Upload from '../../functions/s3Upload';
import {wrapXHR} from '../../functions/wrapXHR';
import request from '../../library/request';
// import {makeDirectApiCall} from '../../library/axios';
import {makeDirectApiCall, getStoredAuthValue} from '../../library/axios';
import store from '../../store';
import setGlobalState from '../setGlobalState';
import {getState} from '../store.type.ts';
import {updateAnalyticsUserId} from '../../utils/analytics';

const getLang =() =>({
    lang:store.getState().user.lang,
    language:store.getState().user.lang
});
const getLangloc=() =>({
    ...(store.getState().user.langloc?{
        langloc: store.getState().user.langloc,
        locale: store.getState().user.langloc.split('_')[1]
    }:{}),
});

const applicationLoginParams = () => store.getState().auth.isApplication ? {loginSource: 'application'} : {};

export const setIsLoginViaApp = (value) => ({
    type: 'SET_IS_LOGIN_VIA_APP',
    payload: value,
});

export const requestUser = async (action, method, path, args, userPath = null) => {
    // let res;
    // if(IS_PRODUCTION){
    //     res = await request(action, method, path, args);
    // }
    // else {
    // const csrfToken = store.getState().auth.csrfToken;
    const csrfToken = getStoredAuthValue('csrfToken') || store.getState().auth.csrfToken;
    const headers = {'X-CSRF-Token': csrfToken};
    const res = await request(action, method, `${USER_API_PATH}${userPath || path}`, {...args}, {headers, withCredentials: true});
    // }
    return res;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const userPackage = async (method, user, isSignUp = false, urlParams = {}) => {
    const body = Object.keys(urlParams).length > 0 ? {urlParams} : {};
    const packageData = await request('user.userPackage', method, '/user/package', body);
    if(packageData?.isInactiveUser){
        return {isInactiveUser: true};
    }
    if(packageData?.noPackageOrEvent) {
        return {noPackageOrEvent: true};
    }
    if(packageData?.pid)
        user.defaultPid = packageData.pid;
    if(packageData?.userInfo)
        user = {...user, ...packageData.userInfo};
    return user;
};

export const isNoPackageOrEvent = (res, email, {completeSignup} = {}) => {
    if(res?.noPackageOrEvent){
        setGlobalState('ui.login.noPackageOrEvent', true);
        setGlobalState('ui.login.existingUserEmail', email);
        // מפנה ישירות למסך טלפון כשמגיעים מ-login עם הרשמת מפיק לא שלמה.
        if(completeSignup) {
            setGlobalState('ui.login.isMissingPhone', true);
        }
        return true;
    }
    return false;
};

export const isInactiveUser = (res)=>{
    if(res?.isInactiveUserEvent || res?.isInactiveUserPackage){
        setGlobalState('ui.login.isInactiveUser',true);
        return;
    }
    return false;
};

export const userSuccess = (res) => {
    // Create a new object to ensure it's extensible
    let user = res.user ? {...res.user} : {};
    if(res.exp) {
        localStorage.setItem('exp', JSON.stringify(res.exp));
        setGlobalState('auth.exp', res.exp);
    }
    if(res.csrfToken){
        localStorage.setItem('csrfToken', JSON.stringify(res.csrfToken));
        // setGlobalState('auth.csrfToken:', res.csrfToken);
        setGlobalState('auth.csrfToken', res.csrfToken);
    }
    setGlobalState('auth.message', '');
    user.isMaster = user.isMaster || false;
    user.nameFirst = user?.firstName;
    user.nameLast = user?.lastName;
    user.lang = user?.language;
    user.picture = user?.profileImage;
    user.langloc= `${user?.lang}_${user?.locale}`;
    user.ownerEmailVerified = user.emailVerified;
    localStorage.setItem('user', JSON.stringify(user));
    setGlobalState('user', user);
    setGlobalState('auth.isLoggedIn',true);

    // Update Analytics with user ID
    updateAnalyticsUserId(user.uid);

    if(store.getState().auth.isApplication && res.applicationToken){
        if(res.applicationExp) {
            localStorage.setItem('applicationExp', JSON.stringify(res.exp));
            setGlobalState('auth.applicationExp', res.exp);

        }
        window.location.href = `${APPLICATION_LOGIN_PATH}?applicationToken=${res.applicationToken}&csrf=${res.csrfToken}&user=${JSON.stringify(user)}`;
    }

};
export const loginUser = async (user,isLoginByPassword) => {
    try {
        const res = await requestUser('user.loginUser', 'post', '/login/', {...user,isLoginByPassword, ...applicationLoginParams(), handleError: true});
        if(res.user){ // && !IS_PRODUCTION
            // const method = res.user.uid ? 'get': 'post';
            const getPackage = await userPackage('get', res.user);
            if(getPackage?.noPackageOrEvent){
                // מפיק בלי חבילה אחרי login+SMS: לא userSuccess, מעבר ל-signup + ניקוי V ירוק.
                if(parseInt(res.user?.isProducer)) {
                    setGlobalState('user.loginUserXHR', null);
                    isNoPackageOrEvent(getPackage, user.email, {completeSignup: true});
                    return;
                }
                isNoPackageOrEvent(getPackage, user.email);
                return;
            }
            if(getPackage?.isInactiveUser){
                return {isInactiveUser: true};
            }
            res.user = getPackage;
        }
        if(typeof Android != 'undefined') {
            // eslint-disable-next-line no-undef
            Android.loginInfo(JSON.stringify(res.user));
        }
        if(isNoPackageOrEvent(res,user.email))
            return ;
        if(isInactiveUser(res))
            return true;
        if(res.isCodeSend)
            return {isCodeSend:true};
        userSuccess(res);
    } catch (error) {
        if(error!== 'user.loginUser is blocked')
            setGlobalState('ui.codeInput.isWrong',true);
    }
};
export const loginByEmail = async (email,sendToEmail) => {
    const sendTo=sendToEmail?'email':'phone';
    const res = await requestUser('user.loginByEmail', 'post', '/loginEmail', {email,sendTo});
    // משתמש לייב/לא מפיק באפפ — מנותב להרשמה (מונע לולאה signup↔login).
    if(res?.isNewUser) {
        isNoPackageOrEvent({noPackageOrEvent: true}, email);
        return true;
    }
    if(!res?.isProducer && res) {
        res.noPackageOrEvent = true;
    }
    isNoPackageOrEvent(res,email);
    if(isInactiveUser(res))
        return true;
    if(res && res[sendTo])
        setGlobalState(`user.${sendTo}`,res[sendTo]);
};

export const getTokenToSignUp = async (user) => {
    const phone = initPhoneNumber({nationalNumber: user.phone, country: user.country}).internationalNumber;
    const res = await requestUser('user.getTokenToSignUp', 'post', '/signUpEmail/', {...user,...getLang(),phone});
    if(res?.maskedPhone || res?.maskedEmail){
        return res;
    }
    if(res?.isExistingUser){
        return {
            isExistingUser: true
        };
    }
    if(!res?.token) {
        return {noToken: true};
    }
    setGlobalState('auth.token', res.token);
};

export const signUp = async (user,password=null,packageType='') => {
    try {
        const phone = initPhoneNumber({nationalNumber: user.phone, country: user.country}).internationalNumber;
        const firstName = user.nameFirst;
        const lastName = user.nameLast;
        const urlParams = user.urlParams || {};
        const res = await requestUser('user.signUp', 'post', '/signUp/', {...user,phone,password,packageType,token:store.getState().auth.token,...getLang(),...getLangloc(), firstName, lastName, handleError: true});
        if(res.user){ // && !IS_PRODUCTION
            res.user = await userPackage('post', res.user, true, urlParams);
            res.pid = res.user.defaultPid;
        }
        if(res?.user){
            userSuccess(res);
            // איפוס מצב השלמת הרשמה אחרי הרשמה מוצלחת.
            setGlobalState('ui.login.isMissingPhone', null);
        }
        return res;
    } catch (error) {
        setGlobalState('ui.codeInput.isWrong',true);
    }
};

export const signUpGoogle = async (user) => {
    const res = await requestUser('user.signUpGoogle', 'post', '/signUpGl/', {...user,...getLang(),...getLangloc()}, '/signUpGoogle');
    isNoPackageOrEvent(res,user.email);
    if(isInactiveUser(res))
        return true;
    if(res.user){
        const user = {
            nameFirst: res.user?.firstName,
            nameLast: res.user?.lastName,
            ...res.user
        };
        return user;
    }
};

export const loginUserGL = async (user) => {
    const res = await requestUser('user.loginUser', 'post', '/loginGl/', {...user, ...applicationLoginParams()}, '/loginGoogle');
    if(res){
        if(res.user){ // && !IS_PRODUCTION
            // const method = res.user.uid ? 'get': 'post';
            res.user = await userPackage('get', res.user);
            userSuccess(res);
        }
        return res;
    }
};
export const loginUserFB = async (user) => {
    const res = await request('user.loginUser', 'post', '/loginFb/', {...user, ...applicationLoginParams()});
    userSuccess(res);
};

export const loginApple = async (user) => {
    const res = await requestUser('user.loginUser', 'post', '/loginApple', {...user, ...applicationLoginParams()});
    if(res.user){ // && !IS_PRODUCTION
        // const method = res.user.uid ? 'get': 'post';
        res.user = await userPackage('get', res.user);
    }
    userSuccess(res);
};

export const signUpApple = async (user) => {
    const res = await requestUser('user.signUpApple', 'post', '/signUpApple', {...user,...getLang(),...getLangloc()});
    isNoPackageOrEvent(res,user.email);
    if(isInactiveUser(res))
        return true;
    if(res.user){
        const user = {
            nameFirst: res.user?.firstName,
            nameLast: res.user?.lastName,
            ...res.user
        };
        return user;
    }
};
export const resetPassword = async (email, password, password2, token) => {
    const res = await requestUser('user.resetPassword', 'post', '/resetPassword/', {email, password, password2, token});
    if(res.isCodeSend) {
        if(res.phone)
            setGlobalState('user.phone',res.phone);
        else
            setGlobalState('user.email',res.email);
        return {isCodeSend:true};
    }
};
export const updatePassword = async (email, password, password2, token, code) => {
    const res = await requestUser('user.updatePassword', 'post', '/updatePassword', {email, password, password2, token, code});
    if(res.response==='OK'){
        return true;
    }
};
export const forgetPassword = async (email) => {
    await requestUser('user.forgetPassword', 'post', '/forgetPassword', {email});
};
export const logout = async () => {
    const socket = store.getState().auth?.socket;
    
    try {
        // Use direct API calls for both operations to completely bypass interceptors
        if(socket) {
            // First handle the socket deletion
            await makeDirectApiCall('delete', '/user/deleteSocket/', {socket});
        }
        
        // Then handle the actual logout call
        await makeDirectApiCall('post', `${USER_API_PATH}/logout/`, {socket});
        
        // Clear Redux state
        setGlobalState('user', {});
        setGlobalState('auth.isLoggedIn', false);
        setGlobalState('auth.exp', null);
        setGlobalState('auth.csrfToken', null);
        
        // Clear Analytics user ID
        updateAnalyticsUserId(null);
        
        // Clear localStorage
        localStorage.removeItem('user');
        localStorage.removeItem('exp');
        localStorage.removeItem('csrfToken');
        localStorage.removeItem('applicationExp');

        // Notify mobile app of logout
        if(window.LoginDetector) {
            window.LoginDetector.postMessage('USER_LOGGED_OUT');
        }

    } catch (error) {
        console.error('Error during logout:', error);
        // Even if API calls fail, still clear state to prevent UI issues
        setGlobalState('user', {});
        setGlobalState('auth.isLoggedIn', false);

        // Clear Analytics user ID
        updateAnalyticsUserId(null);

        // Notify mobile app of logout even on error
        if(window.LoginDetector) {
            window.LoginDetector.postMessage('USER_LOGGED_OUT');
        }
    }
};

export const updateUserDetails = (user) =>
    wrapXHR('user.updateUserDetailsFullXHR', async () => {
        if(user.picture && user.picture !== 'default') {
            user.picture = await uploadFile(user.picture, '', 'profile', user.uid);
        }
        user.profileImage = user.picture;
        const res = await requestUser('user.updateUserDetails', 'put', '/user/', user, '/update');
        if(res.user) {
            userSuccess(res);
        }
    });
export const updateUserEmail = async (user) => {
    const res = await request('user.updateUserEmail', 'put', '/userEmail/', user);
    if(res){
        setGlobalState('account.ownerEmail', res.packageOwnerEmail);
        if(res.userEmail){
            let loggedUser = JSON.parse(localStorage.getItem('user'));
            loggedUser.email = res.userEmail;
            localStorage.setItem('user', JSON.stringify(loggedUser));
            setGlobalState('user.email', res.userEmail);
        }

    }
};
export const updateLocalStorage=(item,fields)=>{
    let localStorageItem = JSON.parse(localStorage.getItem(item));
    localStorageItem={...localStorageItem,...fields};
    localStorage.setItem(item, JSON.stringify(localStorageItem));
};

export const updateUserInfo = (values) =>
    wrapXHR('user.updateUserInfoFullXHR', async () => {
        values = await uploadUserImages(values);
        const res = await request('user.updateUserInfo', 'put', '/user/info', values);
        setGlobalState('user.info', {...store.getState().user.info, ...res});
    });

export const uploadUserImages = async (values)=>{
    if(values.gallery?.length) {
        values.gallery = await Promise.all(values.gallery?.map(async (image, index) =>  await uploadFile(image, '', `userGallery${index}`)));
    }
    if(values.certificate.base64) {
        values.certificate.base64 = await uploadFile(values.certificate.base64, '', 'userCertificate');
    }
    if(values.picture) {
        values.picture = await uploadFile(values.picture, '', 'teamImage');
    }
    return values;
};

export const getUserInfo=async()=>{
    const res=await request('user.getUserInfo', 'get', '/user/info');
    setGlobalState('user.info',res);
};

export const getIsExistingUser = async (user) => {
    const res = await requestUser('user.getIsExistingUser', 'post', '/checkExistingUser/', user);
    if(res.isExistingUser)
        return res;
    setGlobalState('auth.token', res.token);
};

export const getPreSignedUrl = async (mimeType  = 'image/jpeg', uploadType, id)=>{
    const res = await request('design.getPreSignedUrl'+uploadType, 'get', '/user/preSignedUrl', {mimeType, uploadType, id});
    return res;
};

export const uploadFile = async (base64, mimeType , uploadType, id) => {
    try {
        if(base64.substring(0, 4) === 'http') {
            return base64;
        }
        mimeType = mimeType || base64.substring('data:'.length, base64.indexOf(';base64'));
        const urlObj = await getPreSignedUrl(mimeType , uploadType, id);
        if(urlObj?.url){
            const res = await s3Upload(base64, mimeType , urlObj.url, urlObj.key);
            return res;
        } else {
            return null;
        }
    } catch (error){
        return null;
    }
};

export const getUserDetailsIfLoggedIn = async () => {
    const res = await request('user.getUserDetailsIfLoggedIn', 'get', '/user');
    if(res?.user) {
        res.user = await userPackage('get', res.user);
        if(isNoPackageOrEvent(res.user, res.user?.email)) {
            return;
        }
        userSuccess(res);
    }
};

export const updateUserPreferences = async (preferences) => {
    const user = getState().user;
    try {
        await request('user.updateUserPreferences', 'put', '/user/preferences', {userPreferences: preferences});
        setGlobalState('user', {
            ...user,
            preferences: {
                ...user.preferences,
                ...preferences
            }
        });
    } catch (error) {
        console.error('Failed to set user preferences', error);
    }
};  
export const getUserPreferences = async () => {
    const user = getState().user;
    const res = await request('user.getUserPreferences', 'get', '/user/preferences');
    if(res && res.preferences) {
        setGlobalState('user', {
            ...user,
            preferences: {
                ...user.preferences,
                ...res.preferences
            }
        });
    }
    return res;
};

export const updatePhone = async (newPhone, user) => {
    const res = await request('user.updatePhone', 'post', '/support/updatePhone', {newPhone, user, ...getLang()});
    return res;
};
